/**
 * @description Search and replace strings for %%EXPRESSIONS_LIKE_THIS%%
 *
 * @param {string} str - The string to be parsed
 * @param {Object} vars - Object of dynamic substrings
 * @param {Var} vars[key] - The %%EXPRESSION%% to search for
 * @param {string} vars[key] = value - The value of the %%EXPRESSION%% after it's evaluated
 * @param {string} htmlTag - optional html tag to wrap the placeholder value
 *
 * @return {string} parsed string
 */
export function placeholder(str, vars = {}, htmlTag = null) {
  let normalized = str;
  const matches = str.match(/(%% ?[A-Z|_]{1,} ?%%)/g);

  if (matches) {
    // prettier-ignore
    const normalizedMatches = matches.map((match) => {
            const strippedString = match.replace(/(%%)/g, '');
            return strippedString.replace(/(\s)/g, '');
        });

    Object.entries(vars).forEach(([key, value]) => {
      const i = normalizedMatches.indexOf(key);
      let updatedValue = value;

      if (htmlTag) {
        updatedValue = ` ${htmlTag[0]}${value}${htmlTag[1]}`;
      }

      if (i >= 0) {
        normalized = normalized.replace(matches[i], updatedValue);
      }
    });
  }

  return normalized;
}

/**
 * @description wrapper functions to handle strings that have inline link
 * placeholders
 *
 * @param {string} str - The string to be parsed
 * @param {Object} vars - Object of dynamic substrings
 * @param {Var} vars[key] - The %%EXPRESSION%% to search for
 * @param {string} vars[key] = value - The value of the %%EXPRESSION%% after it's evaluated
 * @param {string} link - link the link tag should point to.
 *
 * @return {string} parsed string
 */
export function linkPlaceholder(str, vars = {}, link) {
  const htmlTag = [`<a href="${link}">`, '</a>'];
  return placeholder(str, vars, htmlTag);
}
